<template>
  <div class="product-page data-governance">
    <!-- 页面标题和描述 -->
    <div
      class="page-header"
      :style="{
        backgroundImage: pageData.cover ? `url(${pageData.cover})` : '',
      }"
    >
      <div class="container">
        <h1>{{ pageData.name || "数据治理"  }} </h1>
        <p class="description">{{ pageData.desc }}</p>
      </div>
    </div>

    <!-- 平台介绍 -->
    <section class="section platform-section">
      <div class="container">
        <h2 class="section-title">数据智能平台</h2>
        <div class="platform-content">
          <div class="platform-info">
            <h3>MeinnDM 一站式数据智能平台</h3>
            <p>
              数据智能平台（MeinnDM），包含数据集成，数据开发，数据治理，数据资产，数据服务，数据集市六大模块，解决数据孤岛问题，实现数据统一口径标准，自定义数据开发任务，帮助企业，政府等客户解决数据管理核心难点问题。
            </p>

            <!-- 平台功能模块 -->
            <div class="grid-layout col-3">
              <div
                v-for="(module, index) in modules"
                :key="module.title"
                class="card module-card"
                :style="{ animationDelay: `${index * 0.1}s` }"
              >
                <div class="icon-wrapper">
                  <el-icon :size="32">
                    <component :is="module.icon || DataLine" />
                  </el-icon>
                </div>
                <h3>{{ module.title }}</h3>
                <p>{{ module.description }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 服务能力 -->
    <section class="section capabilities-section">
      <div class="container">
        <h2 class="section-title">服务能力</h2>
        <div class="grid-layout col-3">
          <div
            v-for="(capability, index) in capabilities"
            :key="capability.title"
            class="card capability-card"
            :style="{ animationDelay: `${index * 0.1}s` }"
          >
            <div class="icon-wrapper">
              <el-icon :size="32">
                <component :is="capability.icon || DataLine" />
              </el-icon>
            </div>
            <h3>{{ capability.title }}</h3>
            <p>{{ capability.description }}</p>
            <ul class="feature-list">
              <li v-for="feature in capability.features" :key="feature">
                {{ feature }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <!-- 服务案例 -->
    <!-- <section class="section cases-section">
      <div class="container">
        <h2 class="section-title">服务案例</h2>
        <div class="cases-showcase">
          <div class="case-preview" @mouseleave="activeCase = null">
            <div
              v-for="(item, index) in cases"
              :key="item.title"
              class="case-item"
              :class="{ active: activeCase === index }"
              @mouseenter="activeCase = index"
            >
              <div class="case-image">
                <img src="@/assets/images/1.jpg" :alt="item.title" />
              </div>
              <div class="case-overlay">
                <div class="case-content">
                  <span class="case-number">0{{ index + 1 }}</span>
                  <h3>{{ item.title }}</h3>
                  <div class="tags-wrapper">
                    <span v-for="tag in item.tags" :key="tag" class="tag">{{
                      tag
                    }}</span>
                  </div>
                  <p>{{ item.description }}</p>
                  <div class="highlights-grid">
                    <div
                      v-for="highlight in item.highlights"
                      :key="highlight"
                      class="highlight-item"
                    >
                      {{ highlight }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section> -->
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import {
  DataLine,
  Connection,
  Platform,
  Management,
  TrendCharts,
} from "@element-plus/icons-vue";
import axios from "axios";
import { columnGet2 } from "@/api/court";


const pageData = ref({});

// 获取页面数据
const getPageData = async () => {
  try {
    const response = await columnGet2({
      page: 1,
      limit: 10000,
      is_enable: true,
      parent: 9,
    });
  

    if (response.data.code === 2000) {
      // 根据当前页面名称匹配对应的数据
      const data = response.data.data.data.find((item) => {
        // 根据路径匹配对应的数据
        return (
          item.name.includes("数据治理") ||
          item.name.toLowerCase().includes("data")
        );
      });
      if (data) {
       
        pageData.value = data;

      }
    }
  } catch (error) {
    console.error("获取页面数据失败:", error);
  }
};

onMounted(() => {
  // 确保页面从顶部开始显示
  console.log('📊 数据治理页面组件挂载，确保滚动到顶部')
  document.documentElement.scrollTop = 0
  document.body.scrollTop = 0
  window.scrollTo(0, 0)

  getPageData();
});

// 平台功能模块
const modules = [
  {
    icon: DataLine,
    title: "数据集成",
    description: "多源异构数据采集与整合",
  },
  {
    icon: Connection,
    title: "数据开发",
    description: "灵活的数据开发与处理能力",
  },
  {
    icon: Platform,
    title: "数据治理",
    description: "全方位的数据质量管理",
  },
  {
    icon: Management,
    title: "数据资产",
    description: "完整的数据资产管理体系",
  },
  {
    icon: TrendCharts,
    title: "数据服务",
    description: "便捷的数据服务能力",
  },
  {
    icon: DataLine,
    title: "数据集市",
    description: "高效的数据应用支撑",
  },
];

// 服务能力
const capabilities = [
  {
    icon: DataLine,
    title: "数据治理能力",
    description: "专业的数据治理服务",
    features: ["数据标准化管理", "数据质量管理", "数据生命周期管理"],
  },
  {
    icon: TrendCharts,
    title: "数据分析能力",
    description: "强大的数据分析挖掘能力",
    features: ["数据分析模型", "数据可视化", "数据挖掘算法"],
  },
  {
    icon: Management,
    title: "数据运营能力",
    description: "专业的数据运营服务",
    features: ["数据运营策略制定", "数据运营流程优化", "数据运营效果评估"],
  },
];

// 服务案例
const cases = [
  {
    title: "海南省三亚城市超级大脑",
    description:
      "为三亚市打造城市超级大脑项目，提供全栈技术支撑和运营能力。通过数据治理平台系统，实现数据的全方位归集、清洗、整合与应用，为各级用户提供精准的数据服务。",
    tags: ["智慧城市", "数据治理", "运营服务"],
    highlights: [
      "数据资源整合",
      "数据质量提升",
      "数据服务支撑",
      "运营效果显著",
    ],
  },
  {
    title: "景德镇市大数据资源中心",
    description:
      "为景德镇市建设大数据资源中心，实现数据资源的统一管理和服务。通过标准化的数据治理流程，提升数据质量，发挥数据价值。",
    tags: ["数据中心", "资源管理", "数据治理"],
    highlights: ["数据标准化", "资源统一管理", "数据共享服务", "价值深度挖掘"],
  },
  {
    title: "长沙市智慧城市超级大脑",
    description:
      "助力长沙市构建智慧城市超级大脑，打造数据驱动的智慧城市标杆。通过数据治理和分析，为城市管理和决策提供有力支撑。",
    tags: ["智慧城市", "数据分析", "决策支持"],
    highlights: ["数据融合创新", "智能分析决策", "场景化应用", "效益显著提升"],
  },
  {
    title: "江西省九江市数字修水运营",
    description:
      "为修水县打造数字化治理平台，实现县域治理数字化转型。通过数据运营服务，助力政府提升治理效能。",
    tags: ["数字政府", "运营服务", "治理创新"],
    highlights: ["平台化治理", "数据化运营", "服务化支撑", "效能化提升"],
  },
];

const activeCase = ref(null);
</script>

<style lang="scss" scoped>
@import "@/assets/styles/products.scss";

.data-governance {
  padding-top: 30px;

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
  }

  .platform-content {
    max-width: 1000px;
    margin: 0 auto;
  }

  .platform-info {
    text-align: center;
    margin-bottom: 50px;
    opacity: 0;
    animation: fadeInUp 0.8s ease forwards;

    h3 {
      font-size: 24px;
      margin-bottom: 20px;
      color: #333;
      position: relative;
      display: inline-block;

      &::after {
        content: "";
        position: absolute;
        bottom: -8px;
        left: 0;
        width: 0;
        height: 2px;
        background: #2b5dff;
        animation: lineExpand 0.6s ease 0.8s forwards;
      }
    }

    p {
      font-size: 16px;
      line-height: 1.6;
      color: #666;
      margin-bottom: 40px;
    }
  }

  .card {
    position: relative;
    overflow: hidden;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        135deg,
        rgba(43, 93, 255, 0.1) 0%,
        transparent 100%
      );
      opacity: 0;
      transition: opacity 0.3s ease;
    }

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 8px 30px rgba(43, 93, 255, 0.15);

      &::before {
        opacity: 1;
      }

      .icon-wrapper {
        transform: rotateY(360deg);
      }
    }

    .icon-wrapper {
      transition: transform 0.8s ease;
      transform-style: preserve-3d;
    }
  }

  .module-card {
    animation: fadeInUp 0.6s ease both;
  }

  .capability-card {
    animation: fadeInUp 0.6s ease both;

    .feature-list li {
      opacity: 0;
      transform: translateX(-20px);
      animation: slideInRight 0.4s ease forwards;

      @for $i from 1 through 5 {
        &:nth-child(#{$i}) {
          animation-delay: #{0.2 + $i * 0.1}s;
        }
      }
    }
  }

  .cases-section {
    background: #fff;
    padding: 80px 0;
    overflow: hidden;
  }

  .cases-showcase {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 40px;
  }

  .case-preview {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
    padding: 20px 0;
  }

  .case-item {
    position: relative;
    height: 480px;
    border-radius: 20px;
    overflow: hidden;
    background: #f8f9fc;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
    transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
    cursor: pointer;

    &:hover {
      transform: translateY(-10px);
      box-shadow: 0 8px 30px rgba(43, 93, 255, 0.12);

      .case-image img {
        transform: scale(1.05);
      }

      .case-content {
        transform: translateY(0);
      }
    }

    .case-image {
      width: 100%;
      height: 260px;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.6s ease;
      }
    }

    .case-overlay {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: calc(100% - 260px);
      background: linear-gradient(to bottom, #fff, #f8f9fc);
      padding: 25px;
    }

    .case-content {
      position: relative;
      height: 100%;
      transform: translateY(20%);
      transition: transform 0.4s ease;
      overflow: hidden;

      .case-number {
        font-size: 36px;
        font-weight: 600;
        color: rgba(43, 93, 255, 0.2);
        margin-bottom: 10px;
        display: block;
      }

      h3 {
        font-size: 22px;
        color: #333;
        margin-bottom: 12px;
      }

      .tags-wrapper {
        display: flex;
        gap: 8px;
        margin-bottom: 12px;
        flex-wrap: wrap;

        .tag {
          padding: 4px 12px;
          background: rgba(43, 93, 255, 0.1);
          border-radius: 20px;
          font-size: 13px;
          color: #2b5dff;
          font-weight: 500;
          transition: all 0.3s ease;

          &:hover {
            background: rgba(43, 93, 255, 0.15);
          }
        }
      }

      p {
        font-size: 14px;
        line-height: 1.6;
        color: #666;
        margin-bottom: 15px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }

      .highlights-grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 10px;

        .highlight-item {
          padding: 10px;
          background: #fff;
          border-radius: 10px;
          text-align: center;
          font-size: 13px;
          color: #666;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
          transition: all 0.3s ease;

          &:hover {
            color: #2b5dff;
            background: rgba(43, 93, 255, 0.05);
            transform: translateY(-2px);
          }
        }
      }
    }
  }

  @media screen and (max-width: 1200px) {
    .case-item {
      height: 460px;

      .case-image {
        height: 240px;
      }

      .case-overlay {
        height: calc(100% - 240px);
      }
    }
  }

  @media screen and (max-width: 768px) {
    .cases-showcase {
      padding: 0 20px;
    }

    .case-preview {
      grid-template-columns: 1fr;
      gap: 20px;
    }

    .case-item {
      height: 440px;

      .case-image {
        height: 220px;
      }

      .case-overlay {
        height: calc(100% - 220px);
        padding: 20px;
      }

      .case-content {
        transform: translateY(0);

        .case-number {
          font-size: 32px;
          margin-bottom: 8px;
        }

        h3 {
          font-size: 20px;
          margin-bottom: 10px;
        }

        p {
          -webkit-line-clamp: 3;
          margin-bottom: 12px;
        }

        .highlights-grid {
          grid-template-columns: 1fr;
          gap: 8px;

          .highlight-item {
            padding: 8px;
          }
        }
      }
    }
  }
}

.page-header {
  background-size: cover;
  background-position: center;
  color: #fff;
  padding: 80px 0;
  text-align: center;
  position: relative;
  overflow: hidden;
  margin-bottom: 60px;
  display: flex;
  align-items: center;

  &::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background:rgba(0, 0, 0, 0.5);
    opacity: 0.5;
    z-index: 1;
  }

  .container {
    position: relative;
    z-index: 2;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
  }

  h1 {
    font-size: 36px;
    margin-bottom: 10px;
    position: relative;
    display: inline-block;
    opacity: 0;
    transform: translateY(20px);
    animation: fadeInUp 0.8s ease forwards;
  }

  .description {
    font-size: 18px;
    opacity: 0;
    transform: translateY(20px);
    animation: fadeInUp 0.8s ease forwards 0.2s;
    margin: 20px auto 0;
    max-width: 800px;
    line-height: 1.8;
  }
}

@keyframes dataFlow {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: -100% 0;
  }
}
</style>
